import React, { useEffect, useMemo, useRef, useState } from "react";
import "../SellerReg2/SellerReg2.css";
import registerbg from "../../assets/register-bg.png";
import logo from "../../assets/logo.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import SellerServicesUrl from "../../SellerServicesUrl";

import { defaultCountries, parseCountry, FlagImage } from "react-international-phone";
import "react-international-phone/style.css";

export default function SellerReg2() {
  const navigate = useNavigate();

  /* ================= STATES ================= */
    const countries = useMemo(
    () => defaultCountries.map(parseCountry),
    []
  );

  const [isOpen, setIsOpen] = useState(false);
  const [selectedIso2, setSelectedIso2] = useState("eg");
  const dropdownRef = useRef(null);


  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState("");
  const [code, setCode] = useState("+20");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [area, setArea] = useState("");
  const [address, setAddress] = useState("");
  const [activityType, setActivityType] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [image, setImage] = useState(null);
const [branchAddresses, setBranchAddresses] = useState([""]);
const [space, setSpace] = useState("");
const [documents, setDocuments] = useState(null);
const [socialLink, setSocialLink] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
const [branchesCount, setBranchesCount] = useState("");
// const [period, setPeriod] = useState("");
const [period, setPeriod] = useState("");
const [showSuccess, setShowSuccess] = useState(false);
const [showError, setShowError] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

    useEffect(() => {
    const current = countries.find((c) => c.iso2 === selectedIso2);
    if (current) setCode(`+${current.dialCode}`);
  }, [selectedIso2, countries, setCode]);
  const selectedCountry = countries.find((c) => c.iso2 === selectedIso2);

  /* ================= VALIDATION ================= */
//  const validate = () => {
//   let temp = {};

//   if (!username.trim()) temp.username = "اسم المستخدم مطلوب";

//   const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   if (!email.trim()) temp.email = "البريد الإلكتروني مطلوب";
//   else if (!emailPattern.test(email.trim()))
//     temp.email = "البريد الإلكتروني غير صالح";

//   if (!country) temp.country = " الدولة مطلوبة" ;
//     if (!area) temp.area = "  المدينة مطلوبة";
//         if (!address) temp.address = "العنوان مطلوب";


//   if (!phone) temp.phone = "رقم الجوال مطلوب";
//   else if (phone.length < 7 || phone.length > 12)
//     temp.phone = "رقم الجوال غير صحيح";

//   // if (!password || password.length < 6)
//   //   temp.password = "كلمة المرور لا تقل عن 6 أحرف";
//   if (!password.trim()) {
//   temp.password = "كلمة المرور مطلوبة";
// } else if (password.length < 6) {
//   temp.password = "يجب ألا تقل كلمة المرور عن 6 أحرف";
// }

//   if (!activityType)
//     temp.activityType = "نوع النشاط مطلوب";

//   if (!image)
//     temp.image = "صورة المتجر مطلوبة";

//   if (!branchesCount)
//     temp.branchesCount = "عدد الفروع مطلوب";

//   if (!period)
//     temp.period = "مدة الاشتراك مطلوبة";

//   if (!branchAddress.trim())
//   temp.branchAddress = "عنوان الفرع مطلوب";

// // المساحة
// if (!space.trim())
//   temp.space = "إجمالي المساحة مطلوب";
// else if (isNaN(space) || Number(space) <= 0)
//   temp.space = "المساحة يجب أن تكون رقم صحيح";

// // مدة التعاقد
// if (!period.trim())
//   temp.period = "مدة التعاقد مطلوبة";
// else if (isNaN(period) || Number(period) <= 0)
//   temp.period = "مدة التعاقد يجب أن تكون رقم بالأشهر";

//   setErrors(temp);
//   return Object.keys(temp).length === 0;
// };
// const validate = () => {
//   let temp = {};

//   if (!activityType)
//     temp.activityType = "نوع النشاط مطلوب";

//   if (!branchesCount)
//     temp.branchesCount = "عدد الفروع مطلوب";

//   if (!branchAddresses.trim())
//     temp.branchAddresses = "عنوان الفرع مطلوب";

//   if (!space.trim())
//     temp.space = "إجمالي المساحة مطلوب";
//   else if (isNaN(space) || Number(space) <= 0)
//     temp.space = "المساحة يجب أن تكون رقم صحيح";

//   if (!period.trim())
//     temp.period = "مدة التعاقد مطلوبة";
//   else if (isNaN(period) || Number(period) <= 0)
//     temp.period = "مدة التعاقد يجب أن تكون رقم بالأشهر";

//   setErrors(temp);
//   return Object.keys(temp).length === 0;
// };
const validate = () => {
  let temp = {};

  if (!activityType)
    temp.activityType = "نوع النشاط مطلوب";

  if (!branchesCount)
    temp.branchesCount = "عدد الفروع مطلوب";

  branchAddresses.forEach((addr, index) => {
    if (!addr.trim()) {
      temp[`branch_${index}`] = `عنوان الفرع ${index + 1} مطلوب`;
    }
  });

  if (!space.trim())
    temp.space = "إجمالي المساحة مطلوب";
  else if (isNaN(space) || Number(space) <= 0)
    temp.space = "المساحة يجب أن تكون رقم صحيح";

  if (!period.trim())
    temp.period = "مدة التعاقد مطلوبة";
  else if (isNaN(period) || Number(period) <= 0)
    temp.period = "مدة التعاقد يجب أن تكون رقم بالأشهر";


  setErrors(temp);
  return Object.keys(temp).length === 0;
};
  /* ================= SUBMIT ================= */
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     setLoading(true);
//     setApiError("");
//     const step1 = JSON.parse(localStorage.getItem("sellerRegisterStep1"));

// formData.append("username", step1.username);
// formData.append("phone", step1.phone);
// formData.append("area", step1.area);

//     try {
//       const formData = new FormData();

//       formData.append("type", "saller"); 
//       formData.append("username", username.trim());
//       formData.append("email", email.trim().toLowerCase());
//       formData.append("country", country);
//       formData.append("code_phone", code);
//       formData.append("phone", phone);
//       formData.append("password", password);
//       formData.append("area", area);
//       formData.append("address", address);
//       formData.append("activity_type", activityType);
//       // formData.append("image", image);
// formData.append("commercial_register", image);
//  formData.append("count_branches", branchesCount);
//  formData.append("branches[]", branchesCount);
// formData.append("period", period);
// formData.append("location", address);
// formData.append("city", area);
// formData.append("link", "");
// formData.append("branch_address", branchAddress);
// formData.append("space", space);
// formData.append("documents", documents);
// formData.append("social_link", socialLink);

//       if (referralCode.trim()) {
//         formData.append("referral_by", referralCode);
//       }
// console.log(image);
// console.log(formData.get("image"));
//       const res = await axios.post(
//         BaseUrl + SellerServicesUrl.SellerrRegister,
//         formData
//       );

//       console.log("REGISTER SUCCESS", res.data);
//       navigate("/login");

//     } catch (error) {
//       console.log("REGISTER ERROR", error.response?.data);
//       setApiError(
//         error.response?.data?.message || "فشل إنشاء الحساب"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };
const handleFieldChange = (field, value, index = null) => {
  let error = "";

  if (field === "activityType" && !value) {
    error = "نوع النشاط مطلوب";
  }

  if (field === "branchesCount" && !value) {
    error = "عدد الفروع مطلوب";
  }

  if (field === "branch") {
    if (!value.trim()) {
      error = `عنوان الفرع ${index + 1} مطلوب`;
    }
  }

  if (field === "space") {
    if (!value.trim()) {
      error = "إجمالي المساحة مطلوب";
    } else if (isNaN(value) || Number(value) <= 0) {
      error = "المساحة يجب أن تكون رقم صحيح";
    }
  }

  if (field === "period") {
    if (!value.trim()) {
      error = "مدة التعاقد مطلوبة";
    } else if (isNaN(value) || Number(value) <= 0) {
      error = "مدة التعاقد يجب أن تكون رقم";
    }
  }

  setErrors((prev) => ({
    ...prev,
    ...(field === "branch"
      ? { [`branch_${index}`]: error }
      : { [field]: error }),
  }));
};
const handleSubmit = async (e) => {

e.preventDefault();

if (!validate()) return;

setLoading(true);
setApiError("");

try {

const step1 = JSON.parse(localStorage.getItem("sellerRegisterStep1"));

const formData = new FormData();


formData.append("type","saller");
formData.append("username",step1.username);
formData.append("email",step1.email);
formData.append("country",step1.country);
formData.append("code_phone",step1.code);
formData.append("phone",step1.phone);
formData.append("password",step1.password);
formData.append("area",step1.area);
formData.append("address",step1.address);

if(step1.referralCode){
formData.append("referral_by",step1.referralCode);
}


formData.append("activity_type",activityType);
formData.append("count_branches",branchesCount);
// formData.append("branches[]",branchesCount);
// formData.append("branch_addresses",branchAddresses);
branchAddresses.forEach((addr) => {
  formData.append("branches[]", addr);
});
formData.append("area",space);
formData.append("period",period);
formData.append("documents",documents);
formData.append("social_link",socialLink);

const res = await axios.post(
BaseUrl + SellerServicesUrl.SellerrRegister,
formData
);

console.log(res.data);

localStorage.removeItem("sellerRegisterStep1");

// navigate("/login");
setShowSuccess(true);

} catch(error){

console.log(error.response?.data);
setShowError(true);

setApiError(
error.response?.data?.message || "فشل إنشاء الحساب"
);

} finally {

setLoading(false);

}

};
  /* ================= JSX ================= */
  return (
    <div className="sellerregisteration">
      <div className="container-fluid">
        <div className="row">

          {/* IMAGE */}
          <div className="image col-12 col-md-6 p-0">
            <img src={registerbg} alt="register" className="login-image" />
          </div>

          {/* FORM */}
          <div className="form col-12 col-md-6 d-flex flex-column text-end mt-5 mb-5">
            <div className="mb-4 text-center">
              <img className="sellerreglogo mb-3" src={logo} alt="logo" />
            </div>

            <form onSubmit={handleSubmit}>
          

<div className="row mt-3">

  

  <div className="col-md-6 col-12">
    <label className="pb-2 pt-1">نوع النشاط</label>
    <select
      className="form-control"
      value={activityType}
      onChange={(e) => {setActivityType(e.target.value);
          handleFieldChange("activityType", e.target.value);

      }

      }
    >
      <option value="">ادخل نوع النشاط</option>
      <option value="fashion">ازياء</option>
      <option value="electronics">الكترونيات</option>
      <option value="health">صحة</option>
      <option value="games">ألعاب</option>
      <option value="furniture">أثاث</option>
      <option value="kitchen">مطبخ</option>
      <option value="books">كتب</option>
      <option value="other">اخر</option>
    </select>

    {errors.activityType && (
      <small className="text-danger">{errors.activityType}</small>
    )}
  </div>
<div className="col-12 col-md-6 branchnum">
      <label className="mb-2">عدد الفروع</label>
    <input
      className="form-control pb-2" placeholder="ادخل عدد الفروع "
      value={branchesCount}
      // onChange={(e) => setBranchesCount(e.target.value)}
      onChange={(e) => {
  const count = Number(e.target.value) || 0;
  setBranchesCount(e.target.value);

  const newArr = Array.from({ length: count }, (_, i) => branchAddresses[i] || "");
  setBranchAddresses(newArr);
    handleFieldChange("branchesCount", e.target.value);

}}
    />
    {errors.branchesCount && (
      <small className="text-danger">{errors.branchesCount}</small>
    )}
  </div>
</div>   
{/* <label className="mt-1 pb-2">عنوان الفرع 1</label> */}
{branchAddresses.map((addr, index) => (
  <div key={index} className="mb-4">
    <label className=" pb-2 mt-3">
      عنوان الفرع {index + 1}
    </label>

    <input
      className="form-control"
      placeholder="ادخل عنوان الفرع"
      value={addr}
      onChange={(e) => {
        const updated = [...branchAddresses];
        updated[index] = e.target.value;
        setBranchAddresses(updated);
          handleFieldChange("branch", e.target.value, index);

      }}
    />

    {errors[`branch_${index}`] && (
      <small className="text-danger">
        {errors[`branch_${index}`]}
      </small>
    )}
  </div>
))}

{errors.branchAddresses && (
  <small className="text-danger">{errors.branchAddresses}</small>
)}
<div className="row mb-3">

<div className="col-12 col-md-6 ">
      <label className="">إجمالي المساحة</label>
  
<div
  style={{
    background: "#f5f5f5",
    border: "1px solid #E5E5E5",
    borderRadius: "10px",
    height: "48px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "0 10px"
  }}
>
 <input
  type="text"
  className="pt-3 bg-transparent border-0"
  value={space}
  onChange={(e) => { setSpace(e.target.value);
  
  handleFieldChange("space", e.target.value);
}}
  placeholder="ادخل المساحة"
/>

  <span
    style={{
      fontWeight: "500",
      whiteSpace: "nowrap"
    }}
  >
    م²
  </span>
</div>

 {errors.space && (
  <small className="text-danger">{errors.space}</small>
)}
  </div>

  
<div className="col-12 col-md-6 ">
  
  
  <label className="contract-date">مدة التعاقد</label>

  <div className="" style={{
    background: "#f5f5f5",
    border: "1px solid #E5E5E5",
    borderRadius: "10px",
    overflow: "hidden",
    height: "48px",
    textAlign:"right",
    display: "flex",
    padding:"4px 10px"
    
  }}>

<input

  className=" bg-transparent border-0"
  value={period}
  onChange={(e) => {setPeriod(e.target.value);
      handleFieldChange("period", e.target.value);

  }
  }

/>


    <span  style={{
      padding: "10px 15px",
      background: "#f5f5f5",
      fontWeight: "500",
          display: "flex",
    justifyContent: "flex-end"
    }}>
      أشهر
    </span>
  </div>
  {errors.period && (
  <small className="text-danger">{errors.period}</small>
)}
</div>
</div>   


<label className="mt-2">تحميل السجل التجاري والوثائق</label>

<div className="file-upload pb-3" style={{background:"#da1d1d"}}>
  <label className="upload-btn mx-auto text-white pt-3">
    <i style={{fontSize:"17px"}} className="fa fa-arrow-down ">
    </i>
    إضافة ملف
    <input className=""
      type="file"
      onChange={(e) => {
        const file = e.target.files[0];
        setDocuments(file);
      }}
      hidden
    />
  </label>

  <span className="file-name">
    {documents ? documents.name : ""}
  </span>
</div>


<label className="mt-4">روابط مواقع التواصل الاجتماعي</label>
<input
  className="form-control"
  placeholder="ادخل رابط تواصل"
  value={socialLink}
  onChange={(e) => setSocialLink(e.target.value)}
/>

            

              {/* <button to="/sellerreg2"
                type="submit"
                className="btn w-100 mt-4 text-white"
                style={{ backgroundColor: "#1d3a77", borderRadius: "10px" }}
                disabled={loading}
              >
                التالي
              </button> */}
              <button
                type="submit"
                className="btn w-100 mt-4 text-white"
                style={{ backgroundColor: "#1d3a77", borderRadius: "10px" }}
                disabled={loading}
              >
                {loading ? "جاري إنشاء الحساب..." : "إنشاء حساب"}
              </button>
                    <p className="text-center mt-3">
              تملك حساب؟{" "}
              <Link className="link" onClick={() => navigate("/login")}>
                تسجيل الدخول
              </Link>
            </p>
            </form>

          </div>
        </div>
      </div>
      {showSuccess && (
  <div className="success-modal-overlay">
    <div className="success-modal">
      <div className="success-icon">
        <i className="fa fa-check"></i>
      </div>

      <h3>تم بنجاح</h3>
      <p>تم إنشاء الحساب بنجاح</p>

      <button
        className="success-btn"
        onClick={() => {
          setShowSuccess(false);
          navigate("/login");
        }}
      >
        تسجيل الدخول
      </button>
    </div>
  </div>
)}
{showError && (
  <div className="error-modal-overlay">
    <div className="error-modal">
      <div className="error-icon-wrapper">
        <div className="error-icon">
          <i className="fa fa-times"></i>
        </div>
      </div>

      <h3>حدث خطأ</h3>
      <p>{apiError || "فشل إنشاء الحساب"}</p>

      <button
        className="error-btn"
        onClick={() => setShowError(false)}
      >
        حاول مرة أخرى
      </button>
    </div>
  </div>
)}
    </div>
  );
}